enum ActionType {
  Visit,
  WebAppointment,
  CallAppointment,
  CallAhead,
};

export default ActionType;
